import React from 'react';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { markAsBentoBundleReady } from '@atlassian/jira-spa/src/services/mark-bento-bundle-as-ready/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	PREEVAL_ROUTES,
	AFTER_PAINT_ISSUE_PREEVAL_MARK,
	EXCLUDE_PREEVAL_ROUTES,
	EXCLUDE_BOARD_BACKLOG_PREEVAL_ROUTES,
} from './constants.tsx';

const AfterPaintIssuePreEval = () => {
	const route = useCurrentRoute();

	if (
		process.env.NODE_ENV !== 'development' &&
		PREEVAL_ROUTES.has(route.name) &&
		(!fg('spike_removing_lazyissueapp_from_nin_routes') ||
			!EXCLUDE_PREEVAL_ROUTES.has(route.name)) &&
		(!fg('jsw-disable-issue-app-full-page-load') ||
			!EXCLUDE_BOARD_BACKLOG_PREEVAL_ROUTES.has(route.name))
	) {
		(() => {
			markAsBentoBundleReady(
				import(
					/* webpackChunkName: "async-issue-app--full-page", jiraSpaEntry: "spa-issue" */ '@atlassian/jira-spa-apps-issue'
				),
			);
		})();

		performance.mark(AFTER_PAINT_ISSUE_PREEVAL_MARK);
	}

	return <></>;
};

export default AfterPaintIssuePreEval;
